import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import PublishIcon from '@material-ui/icons/Publish';
import { Button } from '@material-ui/core';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';

interface IAttributesTopBar {
  onNewAttribute: () => void;
  onMassUpdate: () => void;
}

const AttributesTopBar = ({
  onNewAttribute,
  onMassUpdate,
}: IAttributesTopBar) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div>
      <div className={classes.barStyle}>
        <div className={classes.whiteSpace} />
        <Button
          variant="outlined"
          startIcon={<PublishIcon />}
          className={`${classes.buttonStyle} ${classes.massUpdateButton}`}
          onClick={onMassUpdate}
        >
          {t('attributeMassUpdate.modalLabel')}
        </Button>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          className={classes.buttonStyle}
          onClick={onNewAttribute}
        >
          {t('attributes.button.new')}
        </Button>
      </div>
    </div>
  );
};

export default AttributesTopBar;
